import { SerializableObject } from './serializable-object';


export class ResetPasswordViewModel extends SerializableObject {
  public code: string;
  public confirmPassword: string;
  public email: string;
  public password: string;
}
